<template>
    <div class="another-results-container">
        <div class="another-results" v-if="results !== ''">
            <div class="number-results" v-html="getNumberText"></div>
            <div class="action-results">
                Улучшите свой тариф, чтобы обладать всей полнотой данных.
            </div>
            <div class="btn-results">
                <a href="/tarif" class="greenbutton">Улучшить тариф</a>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "HasAnotherResults",
    props: {
        total: {
            type: Number,
            required: true,
        },
        limit: {
            type: Number,
            required: true,
        }
    },
    computed: {
        getNumberText() {
            return "Это не всё — мы нашли ещё " + this.results + "."
        },
        results () {
           if (this.total <= this.limit) {
               return ''
           }
           const anotherCount = this.total - this.limit;

           return anotherCount.formatMoney(0, ' ', ' ') + ' результат' + this.getNoun(anotherCount);
        }
    },
    methods: {
        getNoun(number) {
            let n = Math.abs(number);
            n %= 100;
            if (n >= 5 && n <= 20) {
                return 'ов';
            }
            n %= 10;
            if (n === 1) {
                return '';
            }
            if (n >= 2 && n <= 4) {
                return 'а';
            }
            return 'ов';
        }
    }
}
</script>

<style scoped>
.another-results-container {
    min-height: 40px;
}
.another-results {
    height: 108px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    margin: 30px 0;
    font-family: "Roboto", sans-serif;
    color: #36393C;
}
.number-results {
    font-weight: 700;
    font-size: 16px;
}
.action-results {
    font-weight: 400;
    font-size: 14px;
}
.btn-results {
    padding-top: 10px;
}

</style>
